import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AbstractControl, AsyncValidatorFn, FormControl, FormGroup, UntypedFormGroup} from '@angular/forms';
import {Observable, timer} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {SubaccountsService} from '../../features/subaccounts/subaccounts.service';

@Injectable({
  providedIn: 'root'
})
export class ClientValidators {
  private http = inject(HttpClient);
  private _subaccountsService = inject(SubaccountsService);


  private readonly timer = 500;

  /*
  passwordValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => {
      return timer(this.timer)
        .pipe(
          switchMap(() => {
              return this.utilsService.checkIfPasswordIsValid(control.value).pipe(
                map(res => {
                  return !res.isValid ? {'passwordInvalid': true} : null;
                })
              );
            }
          )
        );
    };
  }


   */

  domainValidator(control: AbstractControl): { [key: string]: any } | null {
      const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i;

      if (!domainRegex.test(control.value)) {
        return { invalidDomain: true };
      }

      return null;
  }

  domainSubdomainsValidator(control: AbstractControl): { [key: string]: any } | null {
    const domainSubdomainsRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)*[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,11}?$/;

    if (!domainSubdomainsRegex.test(control.value)) {
      return { invalidDomain: true };
    }

    return null;
  }

  subdomainValidator(control: FormControl): { [key: string]: any } | null {

    if (!control.value){
      return null;
    }

      const regex = /^([a-zA-Z0-9-]+)$/;

      if (!regex.test(control.value)) {
        return { invalidSubdomain: true };
      }

      return null;
  }

  passwordConfirming(passwordKey: string, confirmPasswordKey: string) {
    return (group: FormGroup): { [key: string]: any } => {
      let password = group.controls[passwordKey];
      let confirmPassword = group.controls[confirmPasswordKey];
      if (password.value !== confirmPassword.value) {
        return {passwordInvalid: true};
      }
      return null;
    }
  }

  _passwordConfirming(c: AbstractControl): { passwordInvalid: boolean } {
    if (c.get('password').value !== c.get('confirm_password').value) {
      return {passwordInvalid: true};
    }
    return null;
  }

  isUniqueEmail(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => {
      return timer(this.timer)
        .pipe(
          switchMap(() => {
              return this._subaccountsService.checkIfAccountExists(control.value).pipe(
                map(res => res['result'] ? {'isUniqueEmail': true} : null )
              );
            }
          )
        );
    };
  }

  repeatPasswordValidator(group: UntypedFormGroup): { [key: string]: any } | null {
    const password = group.controls.password.value;
    const passwordConfirmation = group.controls.confirm_password.value;
    return password === passwordConfirmation ? null : {passwordsNotEqual: true};
  }

}
